export const AUDIT_TRAIL_SHORTCUT_FILTER_KEYS = {
  PRODUCT_ID: "product_id",
  TRADE_FILTER: "trade_filter",
  ACTION_SCOPE: "action_scope",
};

export const AUDIT_TRAIL_SHORTCUT_FILTER_ORDER = [
  AUDIT_TRAIL_SHORTCUT_FILTER_KEYS.PRODUCT_ID,
  AUDIT_TRAIL_SHORTCUT_FILTER_KEYS.TRADE_FILTER,
  AUDIT_TRAIL_SHORTCUT_FILTER_KEYS.ACTION_SCOPE,
];

export const AUDIT_TRAIL_TRADE_FILTER_VALUES = {
  TRADE: "trade",
  TRADE_C: "trade_c",
  TRADE_M: "trade_m",
};

export const AUDIT_TRAIL_ACTION_SCOPE = {
  LATEST: "latest",
  ALL: "all",
};

const LEGACY_IS_TRADED_KEY = "is_traded";

const SHORTCUT_KEY_SET = new Set(AUDIT_TRAIL_SHORTCUT_FILTER_ORDER);

const hasShortcutValue = (value) => value != null && value !== "";

export const pickAuditTrailShortcutFilters = (selectedFilter) => {
  if (!selectedFilter || typeof selectedFilter !== "object") return {};

  return AUDIT_TRAIL_SHORTCUT_FILTER_ORDER.reduce((acc, key) => {
    if (hasShortcutValue(selectedFilter[key])) {
      acc[key] = selectedFilter[key];
    }
    return acc;
  }, {});
};

export const omitAuditTrailShortcutFilters = (selectedFilter) => {
  if (!selectedFilter || typeof selectedFilter !== "object") return {};

  return Object.keys(selectedFilter).reduce((acc, key) => {
    if (!SHORTCUT_KEY_SET.has(key) && key !== LEGACY_IS_TRADED_KEY) {
      acc[key] = selectedFilter[key];
    }
    return acc;
  }, {});
};

export const buildAuditTrailShortcutQueryParams = (selectedFilter) => {
  const shortcuts = pickAuditTrailShortcutFilters(selectedFilter);
  delete shortcuts[LEGACY_IS_TRADED_KEY];

  if (shortcuts[AUDIT_TRAIL_SHORTCUT_FILTER_KEYS.TRADE_FILTER]) {
    delete shortcuts[AUDIT_TRAIL_SHORTCUT_FILTER_KEYS.ACTION_SCOPE];
  }

  if (
    shortcuts[AUDIT_TRAIL_SHORTCUT_FILTER_KEYS.ACTION_SCOPE] ===
    AUDIT_TRAIL_ACTION_SCOPE.LATEST
  ) {
    delete shortcuts[AUDIT_TRAIL_SHORTCUT_FILTER_KEYS.ACTION_SCOPE];
  }

  return shortcuts;
};

export const applyAuditTrailShortcutSelection = (
  selectedFilter,
  key,
  value
) => {
  const next = { ...(selectedFilter || {}) };
  delete next[LEGACY_IS_TRADED_KEY];

  switch (key) {
    case AUDIT_TRAIL_SHORTCUT_FILTER_KEYS.PRODUCT_ID: {
      if (!hasShortcutValue(value)) {
        delete next[key];
        return next;
      }
      next[key] = value;
      return next;
    }
    case AUDIT_TRAIL_SHORTCUT_FILTER_KEYS.ACTION_SCOPE: {
      if (
        !hasShortcutValue(value) ||
        value === AUDIT_TRAIL_ACTION_SCOPE.LATEST
      ) {
        delete next[key];
        return next;
      }
      next[key] = value;
      return next;
    }
    case AUDIT_TRAIL_SHORTCUT_FILTER_KEYS.TRADE_FILTER: {
      if (next[key] === value) {
        delete next[key];
        return next;
      }
      next[key] = value;
      return next;
    }
    default: {
      if (next[key] === value) {
        delete next[key];
        return next;
      }
      next[key] = value;
      return next;
    }
  }
};

export const getAuditTrailFilterGroupMap = (filterButtons) => {
  if (!Array.isArray(filterButtons)) return {};

  return filterButtons.reduce((acc, group) => {
    if (group?.key) {
      acc[group.key] = group;
    }
    return acc;
  }, {});
};

// The Trade Feed icon selects Trade-C in an effect, after the grid has already
// asked for rows. Until that selection is stored, the request still has to be
// company trades or the grid keeps the unfiltered page under a selected Trade-C.
export const withFeedCompanyTradesFilter = (selectedFilter, pending) => {
  const base =
    selectedFilter && typeof selectedFilter === "object"
      ? { ...selectedFilter }
      : {};
  if (!pending) return base;
  base[AUDIT_TRAIL_SHORTCUT_FILTER_KEYS.TRADE_FILTER] =
    AUDIT_TRAIL_TRADE_FILTER_VALUES.TRADE_C;
  return base;
};
